module.exports = __webpack_public_path__ + "static/media/at-the-heart-of-the-consumer-s-news-organic-products.7260c475.jpg";